import {AfterViewInit, Directive, ElementRef, Input, Renderer2} from '@angular/core';

@Directive({
  selector: '[markWithAsterisk]',
})
export class MarkWithAsteriskDirective implements AfterViewInit {
  _markWithAsterisk = true;
  @Input() set markWithAsterisk(value: any) {
    if (typeof value === 'boolean') {
      this._markWithAsterisk = value;
      this.toggleAsterisk();
    }
  }
  get markWithAsterisk() {
    return this._markWithAsterisk;
  }
  constructor(private renderer2: Renderer2, private el: ElementRef) {}

  ngAfterViewInit() {
    this.toggleAsterisk();
  }

  toggleAsterisk() {
    const parent = this.renderer2.parentNode(this.el.nativeElement);
    const asterisk = parent.getElementsByClassName('required-asterisk');
    const label = parent.getElementsByTagName('LABEL');
    const matLabel = parent.getElementsByTagName('MAT-LABEL');
    const lbl = matLabel.length ? matLabel : label;

    if (lbl.length) {
      if (this.markWithAsterisk) {
        // add
        if (!asterisk.length) {
          const span = document.createElement('span');
          span.className = 'required-asterisk';
          span.innerText = '*';

          this.renderer2.appendChild(lbl[0], span);
        }
      } else {
        // remove
        if (asterisk.length) {
          this.renderer2.removeChild(parent, asterisk[0]);
        }
      }
    }
  }
}
